import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import NFCRead from '@helios-interactive/vue-nfc-reader';
import VueMask from 'v-mask'
import Embed from 'v-video-embed'
import VideoBackground from 'vue-responsive-video-background-player'
import VideoBg from 'vue-videobg'
import myVideo from 'vue-video'
 
Vue.component('video-bg', VideoBg, myVideo)

Vue.component('video-background', VideoBackground);

Vue.use(Embed);
Vue.use(VueMask);
// Or as a directive-only
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

// Or only as a filter-only
import { VueMaskFilter } from 'v-mask'
Vue.filter('VMask', VueMaskFilter)

Vue.use(NFCRead, { host: 'http://localhost', port: 3333 });


Vue.use(BootstrapVue)
